import React, { Component } from "react";
import { Switch, message, Spin, Typography, Row, Col, Select, Space } from "antd";
import { Layout, Menu } from "antd5";
import { Form, FormItem, ButtonItem, SelectItem, InputItem, InputNumberItem } from "../../../../Components/Items";
import SelectClientesItem from "../../../../Components/SelectClientesItem";
import SelectUsuariosItem from "../../../../Components/SelectUsuariosItem";
import axios from "axios";
import { connect } from "react-redux";
import { FileTextOutlined, ShopOutlined, AlertOutlined, NotificationOutlined, PlusOutlined, DeleteOutlined, MailOutlined, SendOutlined, AuditOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Sider, Content } = Layout;
const { Option } = Select;

if (typeof document !== "undefined") {
    const styleId = "automatizacion-sidebar-menu-style";
    if (!document.getElementById(styleId)) {
        const styleEl = document.createElement("style");
        styleEl.id = styleId;
        styleEl.textContent = `
            .automatizacion-sidebar-menu.ant-menu-inline {
                border-inline-end: none !important;
            }
            .automatizacion-sidebar-menu .ant-menu-item {
                border-radius: 0 !important;
                margin-inline: 0 !important;
                width: 100% !important;
                border-left: 3px solid transparent;
                transition: border-left-color 0.2s, background 0.2s, color 0.2s;
            }
            .automatizacion-sidebar-menu .ant-menu-item:hover {
                background-color: #f0fcfd !important;
                border-left-color: #00BFD6 !important;
            }
            .automatizacion-sidebar-menu .ant-menu-item.ant-menu-item-selected {
                background-color: #f0fcfd !important;
                border-left: 3px solid #00BFD6 !important;
                color: #00BFD6 !important;
                font-weight: 600;
            }
        `;
        document.head.appendChild(styleEl);
    }
}

const SECTION_TITLES = {
    facturaGlobal: "Factura Global",
    insumos: "Insumos",
    alertasInventario: "Alertas de Inventario",
    notificacionRequisicion: "Notificación de Requisiciones",
    envioReportes: "Envío Automático de Reportes",
    revisionSbc: "Revisión de Salario Base de Cotización",
};

const MENU_ITEMS = [
    { key: "facturaGlobal", icon: <FileTextOutlined />, label: "Factura Global" },
    { key: "insumos", icon: <ShopOutlined />, label: "Insumos" },
    { key: "alertasInventario", icon: <AlertOutlined />, label: "Alertas de Inventario" },
    { key: "notificacionRequisicion", icon: <NotificationOutlined />, label: "Requisiciones" },
    { key: "envioReportes", icon: <MailOutlined />, label: "Envio de Reportes" },
    { key: "revisionSbc", icon: <AuditOutlined />, label: "Revision de SBC" },
];

// Periodicidad de la revisión de SBC. Los valores tienen que ser los que entiende
// esDiaDeEjecucion (erp_backend/Utils/automatizacion/periodicidad.utils.js): ojo que el diario
// se llama "diario", no "diaria".
const PERIODICIDAD_SBC_OPTIONS = [
    { value: "diario", label: "Diario" },
    { value: "semanal", label: "Semanal" },
    { value: "mensual", label: "Mensual" },
];

const PERIODICIDAD_OPTIONS = [
    { value: "semanal", label: "Semanal" },
    { value: "quincenal", label: "Quincenal" },
    { value: "mensual", label: "Mensual" },
];

const DIAS_SEMANA = [
    { value: 1, label: "Lunes" },
    { value: 2, label: "Martes" },
    { value: 3, label: "Miércoles" },
    { value: 4, label: "Jueves" },
    { value: 5, label: "Viernes" },
    { value: 6, label: "Sábado" },
    { value: 0, label: "Domingo" },
];

// Genera opciones del 1 al 31 para días del mes
const DIAS_MES = Array.from({ length: 31 }, (_, i) => ({ value: i + 1, label: `Día ${i + 1}` }));

const REMISIONES_OPTIONS = [
    { value: "semanaPasada", label: "De la semana pasada" },
    { value: "semanaActual", label: "De la semana actual" },
    { value: "quincenaPasada", label: "De la quincena pasada" },
    { value: "mesPasado", label: "Del mes pasado" },
    { value: "mesActual", label: "Del mes actual" },
];

// ── Envío automático de reportes ──
// Espejo de erp_backend/Utils/reportesProgramados/registroReportesProgramados.js.
// tipoPeriodo dice cómo se le aplica el plazo configurado:
//   rango   → periodo [desde, hasta]
//   corte   → reporte de saldos a una fecha de corte
//   ninguno → foto del momento, el plazo no aplica
// `soloSi` es el flag de la empresa que activa el módulo: sin él el reporte no
// aparece en la lista. `formatos` y `plazos` limitan las opciones de los reportes
// que no siguen el molde de tabla plana con cualquier plazo.
const REPORTES_PROGRAMABLES = [
    { value: "ventas", label: "Ventas Generales", tipoPeriodo: "rango" },
    { value: "compras", label: "Compras Generales", tipoPeriodo: "rango" },
    { value: "ordenesDeCompra", label: "Ordenes de Compra", tipoPeriodo: "rango" },
    { value: "pagos", label: "Pagos", tipoPeriodo: "rango" },
    { value: "ingresos", label: "Ingresos", tipoPeriodo: "rango" },
    { value: "entradasSalidas", label: "Entradas Y Salidas", tipoPeriodo: "rango" },
    { value: "cuentasPorCobrar", label: "Cuentas Por Cobrar", tipoPeriodo: "corte" },
    { value: "cuentasPorCobrarAgrupado", label: "Cuentas Por Cobrar Agrupado", tipoPeriodo: "corte" },
    // Mismos reportes, solo con ventas de la tienda en línea o solo con las demás
    { value: "cuentasPorCobrarNormales", label: "Cuentas Por Cobrar (Normales)", tipoPeriodo: "corte", soloSi: "ventaOnline" },
    { value: "cuentasPorCobrarEcommerce", label: "Cuentas Por Cobrar (Ecommerce)", tipoPeriodo: "corte", soloSi: "ventaOnline" },
    { value: "cuentasPorCobrarAgrupadoNormales", label: "Cuentas Por Cobrar Agrupado (Normales)", tipoPeriodo: "corte", soloSi: "ventaOnline" },
    { value: "cuentasPorCobrarAgrupadoEcommerce", label: "Cuentas Por Cobrar Agrupado (Ecommerce)", tipoPeriodo: "corte", soloSi: "ventaOnline" },
    { value: "cuentasPorPagar", label: "Cuentas Por Pagar", tipoPeriodo: "corte" },
    { value: "inventario", label: "Inventario Total", tipoPeriodo: "ninguno" },
    {
        value: "taxidermia",
        label: "Taxidermia",
        tipoPeriodo: "rango",
        soloSi: "taxidermia",
        // Su pantalla no tiene descarga de Excel: son nueve secciones, no una tabla
        formatos: ["pdf"],
        // El reporte se ancla al mes que contiene la fecha, otros plazos engañan
        plazos: ["mesPasado", "mesActual"],
    },
];

const reporteProgramable = (reporteKey) => REPORTES_PROGRAMABLES.find((r) => r.value === reporteKey) || null;

const tipoPeriodoDeReporte = (reporteKey) => reporteProgramable(reporteKey)?.tipoPeriodo || null;

const PERIODICIDAD_ENVIO_OPTIONS = [
    { value: "diario", label: "Diario" },
    { value: "semanal", label: "Semanal" },
    { value: "quincenal", label: "Quincenal" },
    { value: "mensual", label: "Mensual" },
];

const PLAZO_OPTIONS = [
    { value: "diaAnterior", label: "Del día anterior" },
    { value: "semanaPasada", label: "De la semana pasada" },
    { value: "semanaActual", label: "De la semana actual" },
    { value: "quincenaPasada", label: "De la quincena pasada" },
    { value: "quincenaActual", label: "De la quincena actual" },
    { value: "mesPasado", label: "Del mes pasado" },
    { value: "mesActual", label: "Del mes actual" },
    { value: "ultimos7Dias", label: "De los últimos 7 días" },
    { value: "ultimos30Dias", label: "De los últimos 30 días" },
    { value: "anioActual", label: "Del año actual" },
];

const FORMATO_OPTIONS = [
    { value: "excel", label: "Excel" },
    { value: "pdf", label: "PDF" },
];

// Opciones válidas para el reporte elegido: los reportes que solo entienden algunos
// plazos o formatos no deben ofrecer los demás.
const plazosDeReporte = (reporteKey) => {
    const permitidos = reporteProgramable(reporteKey)?.plazos;
    return permitidos ? PLAZO_OPTIONS.filter((p) => permitidos.includes(p.value)) : PLAZO_OPTIONS;
};

const formatosDeReporte = (reporteKey) => {
    const permitidos = reporteProgramable(reporteKey)?.formatos;
    return permitidos ? FORMATO_OPTIONS.filter((f) => permitidos.includes(f.value)) : FORMATO_OPTIONS;
};

// Hora entera (0-23) y no un TimePicker: los pickers de antd v4 de este proyecto
// usan moment, y un número evita serializar un objeto de fecha en el POST.
const HORAS_OPTIONS = Array.from({ length: 24 }, (_, hora) => {
    const sufijo = hora < 12 ? "AM" : "PM";
    const hora12 = hora % 12 === 0 ? 12 : hora % 12;
    return { value: hora, label: `${hora12}:00 ${sufijo}` };
});

class AutomatizacionConfiguracion extends Component {
    formRef = React.createRef();

    state = {
        loading: false,
        selectedSection: "facturaGlobal",
        lotesCaducidades: false,
        objetoImpuestos: [],
        objetoRetenciones: [],
        objetoFormasDePago: [],
        clientesConfig: [],
        isMobile: window.innerWidth < 768,
        // Índice de la programación cuya prueba se está enviando, para bloquear solo ese botón
        pruebaEnviando: null,
    };

    componentDidMount() {
        this.handleResize = () => this.setState({ isMobile: window.innerWidth < 768 });
        window.addEventListener("resize", this.handleResize);
        this.consultarConfiguracion();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    onFinish() {
        this.setState({ loading: true });
        const allValues = this.formRef.current.getFieldsValue(true);
        axios
            .post(
                "empresas/editarConfiguracionAutomatizacion",
                { ...allValues, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha modificado la configuración de automatización");
                } else if (res.data.success === 1) {
                    message.error("No se pudo modificar la configuración");
                } else {
                    message.error("Hubo un error y no se modificó la configuración");
                }
            });
    }

    async consultarConfiguracion() {
        this.setState({ loading: true });
        await axios
            .post(
                "empresas/selectConfiguracionAutomatizacion",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    const configuracion = res.data.configuracion || {};
                    const camposInsumos = configuracion.camposInsumos || {};
                    this.setState({
                        lotesCaducidades: !!res.data.lotesCaducidades,
                        objetoImpuestos: res.data.impuestos || [],
                        objetoRetenciones: res.data.retenciones || [],
                        objetoFormasDePago: (res.data.formasDePago || []).map(v => (
                            <Option value={v._id} key={v._id}>{v.c_FormaPago + ' - ' + v.descripcion}</Option>
                        )),
                        clientesConfig: res.data.clientesConfig || [],
                    });
                    this.formRef.current.setFieldsValue({
                        facturaGlobal: {
                            ...(configuracion.facturaGlobal || {}),
                            clientesIds: configuracion.facturaGlobal?.clientesIds || [],
                            formasDePagoIds: configuracion.facturaGlobal?.formasDePagoIds || [],
                        },
                        camposInsumos: {
                            ...camposInsumos,
                            impuestosPredeterminados: camposInsumos.impuestosPredeterminados || [],
                            retencionesPredeterminadas: camposInsumos.retencionesPredeterminadas || [],
                        },
                        alertasInventario: {
                            ...(configuracion.alertasInventario || {}),
                            correosDestinatarios: configuracion.alertasInventario?.correosDestinatarios || [],
                            usuariosDestinatarios: configuracion.alertasInventario?.usuariosDestinatarios || [],
                        },
                        notificacionRequisicion: {
                            ...(configuracion.notificacionRequisicion || {}),
                            usuariosDestinatarios: configuracion.notificacionRequisicion?.usuariosDestinatarios || [],
                        },
                        revisionSbc: {
                            // Los defaults del modelo sólo aplican al crear el documento; una
                            // empresa con configuración previa no trae el bloque y los campos
                            // llegarían vacíos, así que se repiten aquí.
                            periodicidad: "semanal",
                            diaEnvio: 1,
                            horaEnvio: 7,
                            tolerancia: 0.5,
                            canalInApp: true,
                            ...(configuracion.revisionSbc || {}),
                            correosDestinatarios: configuracion.revisionSbc?.correosDestinatarios || [],
                            usuariosDestinatarios: configuracion.revisionSbc?.usuariosDestinatarios || [],
                        },
                        envioReportes: {
                            ...(configuracion.envioReportes || {}),
                            // Se conserva el _id de cada programación: es la llave con la
                            // que el cron lleva su bitácora para no reenviar lo mismo.
                            programaciones: (configuracion.envioReportes?.programaciones || []).map((p) => ({
                                ...p,
                                formatos: p.formatos || [],
                                correosDestinatarios: p.correosDestinatarios || [],
                                usuariosDestinatarios: p.usuariosDestinatarios || [],
                            })),
                        },
                    });
                } else {
                    message.error("Error: no se encontró configuración de esta empresa");
                }
            });
        this.setState({ loading: false });
    }

    // Solo se ofrecen los reportes de módulos que la empresa tiene activos.
    reportesDisponibles() {
        return REPORTES_PROGRAMABLES.filter((reporte) => !reporte.soloSi || this.props[reporte.soloSi]);
    }

    // Al cambiar de reporte se limpia lo que ya no aplica, para no dejar guardada una
    // combinación que el backend rechazaría (p. ej. "del mes pasado" en un reporte
    // quincenal, o Excel en uno que solo genera PDF).
    onCambiarReporte(name, reporteKey) {
        const form = this.formRef.current;
        const ruta = ["envioReportes", "programaciones", name];
        const plazosValidos = plazosDeReporte(reporteKey).map((p) => p.value);
        const formatosValidos = formatosDeReporte(reporteKey).map((f) => f.value);

        const plazoActual = form.getFieldValue([...ruta, "plazo"]);
        const formatosActuales = form.getFieldValue([...ruta, "formatos"]) || [];
        const cambios = [];

        if (plazoActual && !plazosValidos.includes(plazoActual)) {
            cambios.push({ name: [...ruta, "plazo"], value: null });
        }

        const formatosFiltrados = formatosActuales.filter((f) => formatosValidos.includes(f));
        if (formatosFiltrados.length !== formatosActuales.length) {
            cambios.push({
                name: [...ruta, "formatos"],
                value: formatosFiltrados.length ? formatosFiltrados : formatosValidos,
            });
        }

        if (cambios.length) form.setFields(cambios);
    }

    // Manda la programación en ese momento con lo que hay en pantalla, sin necesidad
    // de guardar primero, para comprobar que el envío automático de verdad llega.
    async enviarPruebaReporte(name) {
        const programacion = this.formRef.current.getFieldValue(["envioReportes", "programaciones", name]) || {};

        if (!programacion.reporteKey) {
            message.warning("Elige un reporte antes de enviar la prueba");
            return;
        }
        const tipoPeriodo = tipoPeriodoDeReporte(programacion.reporteKey);
        if (tipoPeriodo !== "ninguno" && !programacion.plazo) {
            message.warning("Elige el plazo de datos antes de enviar la prueba");
            return;
        }
        if (!programacion.correosDestinatarios?.length && !programacion.usuariosDestinatarios?.length) {
            message.warning("Agrega al menos un correo o un usuario destinatario");
            return;
        }

        this.setState({ pruebaEnviando: name });
        const aviso = message.loading("Generando y enviando el reporte de prueba...", 0);
        try {
            const res = await axios.post(
                "empresas/enviarPruebaReporteProgramado",
                { programacion, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            );
            aviso();
            if (res.data.success === 2) {
                const destinatarios = res.data.destinatarios || [];
                message.success(
                    `Reporte de prueba enviado a ${destinatarios.join(", ")} (${res.data.cantidadFilas} registros)`,
                    6
                );
            } else if (res.data.success === 1) {
                // Caso esperado: el reporte no tiene datos en ese plazo, no es un error
                message.warning(res.data.message, 6);
            } else {
                message.error(res.data.message || "No se pudo enviar el reporte de prueba", 6);
            }
        } catch (error) {
            aviso();
            message.error("Hubo un error y no se pudo enviar el reporte de prueba");
        }
        this.setState({ pruebaEnviando: null });
    }

    renderDivider(title) {
        return (
            <div style={{ borderBottom: "2px solid #f0f0f0", marginBottom: 16, marginTop: 8, paddingBottom: 6 }}>
                <Text strong style={{ fontSize: 14, color: "#444" }}>
                    {title}
                </Text>
            </div>
        );
    }

    renderSectionFacturaGlobal() {
        const labelCol = { span: 10 };
        const wrapperCol = { span: 14 };

        return (
            <>
                {this.renderDivider("Aviso de Factura Global")}
                <Text type="secondary" style={{ display: "block", marginBottom: 16, fontSize: 13 }}>
                    Configura cuándo quieres que el sistema te avise para generar la factura global y qué remisiones te propondrá incluir.
                </Text>
                <div style={{ maxWidth: 480 }}>
                    <FormItem
                        label="Activar aviso"
                        name={["facturaGlobal", "activa"]}
                        valuePropName="checked"
                        margin
                        tooltip="Al activar esta opción el sistema te avisará para generar la factura global"
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                    >
                        <Switch />
                    </FormItem>

                    <FormItem shouldUpdate={(prev, curr) => prev.facturaGlobal?.activa !== curr.facturaGlobal?.activa} noStyle>
                        {({ getFieldValue }) => {
                            if (!getFieldValue(["facturaGlobal", "activa"])) return null;
                            return (
                                <>
                                    <FormItem
                                        label="Periodicidad del aviso"
                                        name={["facturaGlobal", "periodicidad"]}
                                        margin
                                        tooltip="Con qué frecuencia el sistema te avisará para generar la factura global"
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <SelectItem
                                            placeholder="Seleccione periodicidad"
                                            style={{ width: "100%" }}
                                            options={PERIODICIDAD_OPTIONS}
                                        />
                                    </FormItem>

                                    <FormItem shouldUpdate={(prev, curr) => prev.facturaGlobal?.periodicidad !== curr.facturaGlobal?.periodicidad} noStyle>
                                        {({ getFieldValue: gfv }) => {
                                            const periodicidad = gfv(["facturaGlobal", "periodicidad"]);
                                            if (!periodicidad) return null;
                                            const esSemanal = periodicidad === "semanal";
                                            const opciones = esSemanal ? DIAS_SEMANA : DIAS_MES;
                                            const label = esSemanal ? "Día de aviso" : "Día del mes para avisar";
                                            const tooltip = esSemanal
                                                ? "El sistema te avisará ese día de la semana"
                                                : "El sistema te avisará ese día del mes (ej. día 1, día 15, día 31)";
                                            return (
                                                <FormItem
                                                    label={label}
                                                    name={["facturaGlobal", "diaAviso"]}
                                                    margin
                                                    tooltip={tooltip}
                                                    labelCol={labelCol}
                                                    wrapperCol={wrapperCol}
                                                >
                                                    <SelectItem placeholder="Seleccione día" style={{ width: "100%" }}>
                                                        {opciones.map((o) => (
                                                            <Option key={o.value} value={o.value}>{o.label}</Option>
                                                        ))}
                                                    </SelectItem>
                                                </FormItem>
                                            );
                                        }}
                                    </FormItem>

                                    <FormItem
                                        label="Remisiones a proponer"
                                        name={["facturaGlobal", "remisiones"]}
                                        margin
                                        tooltip="Qué remisiones propondrá el sistema incluir al generar la factura global"
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <SelectItem
                                            placeholder="Seleccione periodo de remisiones"
                                            style={{ width: "100%" }}
                                            options={REMISIONES_OPTIONS}
                                        />
                                    </FormItem>
                                    <FormItem
                                        label="Filtrar por clientes"
                                        name={["facturaGlobal", "clientesIds"]}
                                        margin
                                        tooltip="Solo se propondrán remisiones de los clientes seleccionados. Vacío = todos los clientes."
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <SelectClientesItem
                                            empresaId={this.props.empresaId}
                                            headersToken={this.props.headersToken}
                                            mode="multiple"
                                            placeholder="Todos los clientes"
                                            initialOptions={this.state.clientesConfig}
                                        />
                                    </FormItem>
                                    <FormItem
                                        label="Filtrar por forma de pago"
                                        name={["facturaGlobal", "formasDePagoIds"]}
                                        margin
                                        tooltip="Solo se propondrán remisiones con estas formas de pago. Vacío = todas."
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <SelectItem
                                            mode="multiple"
                                            placeholder="Todas las formas de pago"
                                            style={{ width: "100%" }}
                                        >
                                            {this.state.objetoFormasDePago}
                                        </SelectItem>
                                    </FormItem>
                                </>
                            );
                        }}
                    </FormItem>
                </div>
            </>
        );
    }

    renderSectionInsumos() {
        const { lotesCaducidades, objetoImpuestos, objetoRetenciones } = this.state;
        const labelCol = { span: 17 };
        const wrapperCol = { span: 7 };

        const campo = (label, name, tooltip) => (
            <FormItem
                label={label}
                name={["camposInsumos", name]}
                margin
                valuePropName="checked"
                tooltip={tooltip}
                labelCol={labelCol}
                wrapperCol={wrapperCol}
            >
                <Switch />
            </FormItem>
        );

        return (
            <>
                {this.renderDivider("Configuración al agregar un insumo")}
                <Text type="secondary" style={{ display: "block", marginBottom: 16, fontSize: 13 }}>
                    Activa los campos que aparecerán por defecto y configura los impuestos/retenciones predeterminados.
                </Text>
                <Row gutter={[32, 0]}>
                    <Col xs={24} md={10}>
                        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, color: "#444" }}>
                            Campos visibles
                        </div>
                        {campo("Venta", "venta", "Mostrar campo de venta al agregar insumo")}
                        {campo("Compra", "compra", "Mostrar campo de compra al agregar insumo")}
                        {campo("Ver insumo en venta", "verInsumoVenta", "Mostrar opción de visualización en venta")}
                        {campo("Leyenda de venta", "leyendaVenta", "Mostrar campo de leyenda de venta")}
                        {campo("Observaciones", "observaciones", "Mostrar campo de observaciones generales")}
                        {campo("Observaciones de venta", "observacionesVenta", "Mostrar campo de observaciones de venta")}
                        {campo("Inventariable", "inventariable", "Mostrar campo de inventariable")}
                        {lotesCaducidades && campo("Lotes y Caducidades", "lotesCaducidades", "Mostrar campo de lotes y caducidades")}
                    </Col>

                    <Col xs={24} md={7}>
                        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, color: "#444" }}>
                            Impuestos predeterminados
                        </div>
                        <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 8 }}>
                            Se asignarán automáticamente al crear un insumo.
                        </Text>
                        <Form.List name={["camposInsumos", "impuestosPredeterminados"]}>
                            {(fields, { add, remove }) => (
                                <>
                                    <div style={{ maxHeight: 200, overflowY: "auto", paddingRight: 4 }}>
                                        {fields.map(({ name }, idx) => (
                                            <Row key={idx} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                                <Col flex="1">
                                                    <FormItem name={[name, "impuestoId"]} required noStyle>
                                                        <SelectItem width="100%" placeholder="Impuesto" size="small">
                                                            {objetoImpuestos.map((v) => (
                                                                <Option key={v._id} value={v._id}>{v.nombre}</Option>
                                                            ))}
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>
                                                <Col flex="28px" style={{ textAlign: "center" }}>
                                                    <DeleteOutlined
                                                        style={{ color: "#ff4d4f", cursor: "pointer", fontSize: 16 }}
                                                        onClick={() => remove(name)}
                                                    />
                                                </Col>
                                            </Row>
                                        ))}
                                    </div>
                                    <ButtonItem type="dashed" onClick={() => add()} icon={<PlusOutlined />} size="small" block style={{ marginTop: 4 }}>
                                        Agregar
                                    </ButtonItem>
                                </>
                            )}
                        </Form.List>
                    </Col>

                    <Col xs={24} md={7}>
                        <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 8, color: "#444" }}>
                            Retenciones predeterminadas
                        </div>
                        <Text type="secondary" style={{ fontSize: 12, display: "block", marginBottom: 8 }}>
                            Se asignarán automáticamente al crear un insumo.
                        </Text>
                        <Form.List name={["camposInsumos", "retencionesPredeterminadas"]}>
                            {(fields, { add, remove }) => (
                                <>
                                    <div style={{ maxHeight: 200, overflowY: "auto", paddingRight: 4 }}>
                                        {fields.map(({ name }, idx) => (
                                            <Row key={idx} gutter={6} style={{ marginBottom: 6 }} align="middle">
                                                <Col flex="1">
                                                    <FormItem name={[name, "retencionId"]} required noStyle>
                                                        <SelectItem width="100%" placeholder="Retención" size="small">
                                                            {objetoRetenciones.map((v) => (
                                                                <Option key={v._id} value={v._id}>{v.nombre}</Option>
                                                            ))}
                                                        </SelectItem>
                                                    </FormItem>
                                                </Col>
                                                <Col flex="28px" style={{ textAlign: "center" }}>
                                                    <DeleteOutlined
                                                        style={{ color: "#ff4d4f", cursor: "pointer", fontSize: 16 }}
                                                        onClick={() => remove(name)}
                                                    />
                                                </Col>
                                            </Row>
                                        ))}
                                    </div>
                                    <ButtonItem type="dashed" onClick={() => add()} icon={<PlusOutlined />} size="small" block style={{ marginTop: 4 }}>
                                        Agregar
                                    </ButtonItem>
                                </>
                            )}
                        </Form.List>
                    </Col>
                </Row>
            </>
        );
    }

    renderSectionAlertasInventario() {
        const labelCol = { span: 14 };
        const wrapperCol = { span: 10 };

        return (
            <>
                {this.renderDivider("Alertas de Stock Mínimo")}
                <Text type="secondary" style={{ display: "block", marginBottom: 16, fontSize: 13 }}>
                    Configura cómo y cuándo el sistema te avisa cuando un insumo llega a su cantidad mínima, y si debe generar o solo sugerir la requisición de reabastecimiento.
                </Text>
                <div style={{ maxWidth: 520 }}>
                    <FormItem
                        label="Activar alertas de stock mínimo"
                        name={["alertasInventario", "activa"]}
                        valuePropName="checked"
                        margin
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                    >
                        <Switch />
                    </FormItem>

                    <FormItem shouldUpdate={(prev, curr) => prev.alertasInventario?.activa !== curr.alertasInventario?.activa} noStyle>
                        {({ getFieldValue }) => {
                            if (!getFieldValue(["alertasInventario", "activa"])) return null;
                            return (
                                <>
                                    <FormItem
                                        label="Notificación dentro del ERP"
                                        name={["alertasInventario", "canalInApp"]}
                                        valuePropName="checked"
                                        margin
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <Switch />
                                    </FormItem>

                                    <FormItem
                                        label="Notificación por app móvil"
                                        name={["alertasInventario", "canalApp"]}
                                        valuePropName="checked"
                                        margin
                                        tooltip="Llega como push a los usuarios destinatarios que tengan la app móvil vinculada a su cuenta"
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <Switch />
                                    </FormItem>

                                    <FormItem
                                        label="Notificación por correo"
                                        name={["alertasInventario", "canalCorreo"]}
                                        valuePropName="checked"
                                        margin
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <Switch />
                                    </FormItem>

                                    <FormItem shouldUpdate={(prev, curr) => prev.alertasInventario?.canalCorreo !== curr.alertasInventario?.canalCorreo} noStyle>
                                        {({ getFieldValue: gfv }) => {
                                            if (!gfv(["alertasInventario", "canalCorreo"])) return null;
                                            return (
                                                <>
                                                    <FormItem
                                                        label="Correos destinatarios"
                                                        name={["alertasInventario", "correosDestinatarios"]}
                                                        margin
                                                        tooltip="Escribe un correo y presiona Enter para agregarlo"
                                                        labelCol={labelCol}
                                                        wrapperCol={wrapperCol}
                                                    >
                                                        <SelectItem mode="tags" placeholder="correo@ejemplo.com" style={{ width: "100%" }} />
                                                    </FormItem>
                                                    <FormItem
                                                        label="Usuarios destinatarios"
                                                        name={["alertasInventario", "usuariosDestinatarios"]}
                                                        margin
                                                        labelCol={labelCol}
                                                        wrapperCol={wrapperCol}
                                                    >
                                                        <SelectUsuariosItem
                                                            empresaId={this.props.empresaId}
                                                            headersToken={this.props.headersToken}
                                                            placeholder="Selecciona usuarios"
                                                        />
                                                    </FormItem>
                                                </>
                                            );
                                        }}
                                    </FormItem>

                                    <FormItem
                                        label="Generar requisición automáticamente"
                                        name={["alertasInventario", "generarRequisicionAutomatica"]}
                                        valuePropName="checked"
                                        margin
                                        tooltip="Si está activo, el sistema crea la requisición directamente. Si está apagado, solo la sugiere para que la confirmes en 'Sugerencias de Requisición'. Se puede sobreescribir por regla individual en Control de Inventario."
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <Switch />
                                    </FormItem>
                                </>
                            );
                        }}
                    </FormItem>
                </div>
            </>
        );
    }

    renderSectionRevisionSbc() {
        const labelCol = { span: 14 };
        const wrapperCol = { span: 10 };

        return (
            <>
                {this.renderDivider("Revisión de Salario Base de Cotización")}
                <Text type="secondary" style={{ display: "block", marginBottom: 16, fontSize: 13 }}>
                    Revisa periódicamente qué empleados activos tienen el SBC desfasado respecto al que sale de su tabla de prestaciones (salario diario por el factor de integración que les toca según su antigüedad) y te avisa. El detalle y la corrección en bloque están en la pantalla de Empleados.
                </Text>
                <div style={{ maxWidth: 520 }}>
                    <FormItem
                        label="Activar revisión de SBC"
                        name={["revisionSbc", "activa"]}
                        valuePropName="checked"
                        margin
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                    >
                        <Switch />
                    </FormItem>

                    <FormItem shouldUpdate={(prev, curr) => prev.revisionSbc?.activa !== curr.revisionSbc?.activa} noStyle>
                        {({ getFieldValue }) => {
                            if (!getFieldValue(["revisionSbc", "activa"])) return null;
                            return (
                                <>
                                    <FormItem
                                        label="Periodicidad"
                                        name={["revisionSbc", "periodicidad"]}
                                        margin
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <SelectItem placeholder="Periodicidad" style={{ width: "100%" }}>
                                            {PERIODICIDAD_SBC_OPTIONS.map((o) => (
                                                <Option value={o.value} key={o.value}>{o.label}</Option>
                                            ))}
                                        </SelectItem>
                                    </FormItem>

                                    {/* El día sólo tiene sentido si no es diaria, y lo que significa
                                        cambia entre semanal (día de la semana) y mensual (día del mes). */}
                                    <FormItem shouldUpdate={(prev, curr) => prev.revisionSbc?.periodicidad !== curr.revisionSbc?.periodicidad} noStyle>
                                        {({ getFieldValue: gfv }) => {
                                            const periodicidad = gfv(["revisionSbc", "periodicidad"]);
                                            if (periodicidad === "diario" || !periodicidad) return null;
                                            const opciones = periodicidad === "semanal" ? DIAS_SEMANA : DIAS_MES;
                                            return (
                                                <FormItem
                                                    label={periodicidad === "semanal" ? "Día de la semana" : "Día del mes"}
                                                    name={["revisionSbc", "diaEnvio"]}
                                                    margin
                                                    labelCol={labelCol}
                                                    wrapperCol={wrapperCol}
                                                >
                                                    <SelectItem placeholder="Día" style={{ width: "100%" }}>
                                                        {opciones.map((o) => (
                                                            <Option value={o.value} key={o.value}>{o.label}</Option>
                                                        ))}
                                                    </SelectItem>
                                                </FormItem>
                                            );
                                        }}
                                    </FormItem>

                                    <FormItem
                                        label="Hora del aviso"
                                        name={["revisionSbc", "horaEnvio"]}
                                        margin
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <SelectItem placeholder="Hora" style={{ width: "100%" }}>
                                            {HORAS_OPTIONS.map((o) => (
                                                <Option value={o.value} key={o.value}>{o.label}</Option>
                                            ))}
                                        </SelectItem>
                                    </FormItem>

                                    <FormItem
                                        label="Tolerancia en pesos"
                                        name={["revisionSbc", "tolerancia"]}
                                        margin
                                        tooltip="Diferencia que se deja pasar antes de marcar un SBC. Medio peso absorbe centavos de redondeo sin dejar pasar un factor de antigüedad equivocado, que mueve pesos."
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <InputNumberItem placeholder="0.50" dinero min={0} />
                                    </FormItem>

                                    <FormItem
                                        label="Notificación dentro del ERP"
                                        name={["revisionSbc", "canalInApp"]}
                                        valuePropName="checked"
                                        margin
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <Switch />
                                    </FormItem>

                                    <FormItem
                                        label="Notificación por correo"
                                        name={["revisionSbc", "canalCorreo"]}
                                        valuePropName="checked"
                                        margin
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <Switch />
                                    </FormItem>

                                    <FormItem shouldUpdate={(prev, curr) => prev.revisionSbc?.canalCorreo !== curr.revisionSbc?.canalCorreo} noStyle>
                                        {({ getFieldValue: gfv }) => {
                                            if (!gfv(["revisionSbc", "canalCorreo"])) return null;
                                            return (
                                                <>
                                                    <FormItem
                                                        label="Correos destinatarios"
                                                        name={["revisionSbc", "correosDestinatarios"]}
                                                        margin
                                                        tooltip="Escribe un correo y presiona Enter para agregarlo"
                                                        labelCol={labelCol}
                                                        wrapperCol={wrapperCol}
                                                    >
                                                        <SelectItem mode="tags" placeholder="correo@ejemplo.com" style={{ width: "100%" }} />
                                                    </FormItem>
                                                    <FormItem
                                                        label="Usuarios destinatarios"
                                                        name={["revisionSbc", "usuariosDestinatarios"]}
                                                        margin
                                                        labelCol={labelCol}
                                                        wrapperCol={wrapperCol}
                                                    >
                                                        <SelectUsuariosItem
                                                            empresaId={this.props.empresaId}
                                                            headersToken={this.props.headersToken}
                                                            placeholder="Selecciona usuarios"
                                                        />
                                                    </FormItem>
                                                </>
                                            );
                                        }}
                                    </FormItem>
                                </>
                            );
                        }}
                    </FormItem>
                </div>
            </>
        );
    }

    renderSectionNotificacionRequisicion() {
        const labelCol = { span: 14 };
        const wrapperCol = { span: 10 };

        return (
            <>
                {this.renderDivider("Notificación al Crear Requisición")}
                <Text type="secondary" style={{ display: "block", marginBottom: 16, fontSize: 13 }}>
                    Elige a qué usuarios avisar cuando se cree una requisición, ya sea manual o generada automáticamente. Se les notifica dentro del ERP y por correo, al correo registrado de cada usuario.
                </Text>
                <div style={{ maxWidth: 520 }}>
                    <FormItem
                        label="Activar notificación al crear requisición"
                        name={["notificacionRequisicion", "activa"]}
                        valuePropName="checked"
                        margin
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                    >
                        <Switch />
                    </FormItem>

                    <FormItem shouldUpdate={(prev, curr) => prev.notificacionRequisicion?.activa !== curr.notificacionRequisicion?.activa} noStyle>
                        {({ getFieldValue }) => {
                            if (!getFieldValue(["notificacionRequisicion", "activa"])) return null;
                            return (
                                <FormItem
                                    label="Usuarios a notificar"
                                    name={["notificacionRequisicion", "usuariosDestinatarios"]}
                                    margin
                                    tooltip="Se les enviará una notificación dentro del ERP y un correo a su cuenta cada vez que se cree una requisición"
                                    labelCol={labelCol}
                                    wrapperCol={wrapperCol}
                                >
                                    <SelectUsuariosItem
                                        empresaId={this.props.empresaId}
                                        headersToken={this.props.headersToken}
                                        placeholder="Selecciona usuarios"
                                    />
                                </FormItem>
                            );
                        }}
                    </FormItem>
                </div>
            </>
        );
    }

    renderProgramacionReporte(field, remove) {
        // key va al contenedor y fieldKey (en restField) a cada campo, para que antd
        // reconcilie bien al eliminar una programación de en medio de la lista.
        const { key, name, ...restField } = field;
        const labelCol = { span: 9 };
        const wrapperCol = { span: 15 };

        return (
            <div
                key={key}
                style={{
                    border: "1px solid #f0f0f0",
                    borderLeft: "3px solid #00BFD6",
                    borderRadius: 6,
                    padding: "12px 16px 4px",
                    marginBottom: 12,
                    background: "#fcfeff",
                }}
            >
                {/* El _id lo genera Mongoose al primer guardado. Viaja oculto para que
                    no cambie al reeditar y la bitácora del cron siga siendo válida. */}
                <FormItem {...restField} name={[name, "_id"]} hidden>
                    <InputItem />
                </FormItem>

                <Row gutter={[24, 0]}>
                    <Col xs={24} md={12}>
                        <FormItem
                            label="Nombre"
                            {...restField}
                            name={[name, "nombre"]}
                            margin
                            tooltip="Solo para identificar esta programación en esta lista"
                            labelCol={labelCol}
                            wrapperCol={wrapperCol}
                        >
                            <InputItem placeholder="Ej. Ventas semanal a dirección" />
                        </FormItem>

                        <FormItem
                            label="Reporte"
                            {...restField}
                            name={[name, "reporteKey"]}
                            margin
                            labelCol={labelCol}
                            wrapperCol={wrapperCol}
                        >
                            <SelectItem
                                placeholder="Seleccione reporte"
                                style={{ width: "100%" }}
                                options={this.reportesDisponibles()}
                                onChange={(valor) => this.onCambiarReporte(name, valor)}
                            />
                        </FormItem>

                        <FormItem
                            label="Periodicidad"
                            {...restField}
                            name={[name, "periodicidad"]}
                            margin
                            tooltip="Cada cuándo se envía el reporte"
                            labelCol={labelCol}
                            wrapperCol={wrapperCol}
                        >
                            <SelectItem
                                placeholder="Seleccione periodicidad"
                                style={{ width: "100%" }}
                                options={PERIODICIDAD_ENVIO_OPTIONS}
                            />
                        </FormItem>

                        <FormItem
                            shouldUpdate={(prev, curr) =>
                                prev.envioReportes?.programaciones?.[name]?.periodicidad !==
                                curr.envioReportes?.programaciones?.[name]?.periodicidad
                            }
                            noStyle
                        >
                            {({ getFieldValue }) => {
                                const periodicidad = getFieldValue(["envioReportes", "programaciones", name, "periodicidad"]);
                                if (!periodicidad || periodicidad === "diario") return null;
                                const esSemanal = periodicidad === "semanal";
                                return (
                                    <FormItem
                                        label={esSemanal ? "Día de envío" : "Día del mes"}
                                        {...restField}
                                        name={[name, "diaEnvio"]}
                                        margin
                                        tooltip={
                                            periodicidad === "quincenal"
                                                ? "Se envía ese día y 15 días después"
                                                : esSemanal
                                                    ? "Se envía ese día de la semana"
                                                    : "Se envía ese día de cada mes"
                                        }
                                        labelCol={labelCol}
                                        wrapperCol={wrapperCol}
                                    >
                                        <SelectItem
                                            placeholder="Seleccione día"
                                            style={{ width: "100%" }}
                                            options={esSemanal ? DIAS_SEMANA : DIAS_MES}
                                        />
                                    </FormItem>
                                );
                            }}
                        </FormItem>

                        <FormItem
                            label="Hora de envío"
                            {...restField}
                            name={[name, "horaEnvio"]}
                            margin
                            tooltip="Hora del centro de México"
                            labelCol={labelCol}
                            wrapperCol={wrapperCol}
                        >
                            <SelectItem
                                placeholder="Seleccione hora"
                                style={{ width: "100%" }}
                                options={HORAS_OPTIONS}
                            />
                        </FormItem>
                    </Col>

                    <Col xs={24} md={12}>
                        <FormItem
                            shouldUpdate={(prev, curr) =>
                                prev.envioReportes?.programaciones?.[name]?.reporteKey !==
                                curr.envioReportes?.programaciones?.[name]?.reporteKey
                            }
                            noStyle
                        >
                            {({ getFieldValue }) => {
                                const reporteKey = getFieldValue(["envioReportes", "programaciones", name, "reporteKey"]);
                                const tipoPeriodo = tipoPeriodoDeReporte(reporteKey);
                                const esCorte = tipoPeriodo === "corte";
                                const formatos = formatosDeReporte(reporteKey);
                                const soloUnFormato = formatos.length === 1;

                                return (
                                    <>
                                        {/* Inventario Total es una foto del momento: no acepta fechas,
                                            así que no se ofrece un plazo que no haría nada. */}
                                        {tipoPeriodo === "ninguno" ? (
                                            <div style={{ marginBottom: 12 }}>
                                                <Text type="secondary" style={{ fontSize: 12 }}>
                                                    Este reporte es una foto del inventario al momento del envío, no
                                                    depende de un plazo.
                                                </Text>
                                            </div>
                                        ) : (
                                            <FormItem
                                                label={esCorte ? "Fecha de corte" : "Plazo de datos"}
                                                {...restField}
                                                name={[name, "plazo"]}
                                                margin
                                                tooltip={
                                                    esCorte
                                                        ? "Los saldos se calculan al último día del plazo elegido"
                                                        : "Qué periodo de información incluye el reporte"
                                                }
                                                labelCol={labelCol}
                                                wrapperCol={wrapperCol}
                                            >
                                                <SelectItem
                                                    placeholder="Seleccione plazo"
                                                    style={{ width: "100%" }}
                                                    options={plazosDeReporte(reporteKey)}
                                                />
                                            </FormItem>
                                        )}

                                        <FormItem
                                            label="Formatos"
                                            {...restField}
                                            name={[name, "formatos"]}
                                            margin
                                            tooltip={
                                                soloUnFormato
                                                    ? `Este reporte solo se puede adjuntar en ${formatos[0].label}`
                                                    : "Archivos que se adjuntan. Vacío = Excel y PDF"
                                            }
                                            labelCol={labelCol}
                                            wrapperCol={wrapperCol}
                                        >
                                            <SelectItem
                                                mode="multiple"
                                                placeholder={formatos.map((f) => f.label).join(" y ")}
                                                style={{ width: "100%" }}
                                                options={formatos}
                                            />
                                        </FormItem>
                                    </>
                                );
                            }}
                        </FormItem>

                        <FormItem
                            label="Correos destinatarios"
                            {...restField}
                            name={[name, "correosDestinatarios"]}
                            margin
                            tooltip="Escribe un correo y presiona Enter para agregarlo"
                            labelCol={labelCol}
                            wrapperCol={wrapperCol}
                        >
                            <SelectItem mode="tags" placeholder="correo@ejemplo.com" style={{ width: "100%" }} />
                        </FormItem>

                        <FormItem
                            label="Usuarios destinatarios"
                            {...restField}
                            name={[name, "usuariosDestinatarios"]}
                            margin
                            tooltip="Se manda al correo registrado de cada usuario"
                            labelCol={labelCol}
                            wrapperCol={wrapperCol}
                        >
                            <SelectUsuariosItem
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                                placeholder="Selecciona usuarios"
                            />
                        </FormItem>

                        <Row align="middle" justify="space-between">
                            <Col>
                                <FormItem
                                    label="Activa"
                                    {...restField}
                                    name={[name, "activa"]}
                                    valuePropName="checked"
                                    margin
                                    labelCol={{ span: 14 }}
                                    wrapperCol={{ span: 10 }}
                                >
                                    <Switch />
                                </FormItem>
                            </Col>
                            <Col>
                                <Space size={8}>
                                    <ButtonItem
                                        cyanB
                                        size="small"
                                        icon={<SendOutlined />}
                                        loading={this.state.pruebaEnviando === name}
                                        disabled={this.state.pruebaEnviando !== null}
                                        onClick={() => this.enviarPruebaReporte(name)}
                                    >
                                        Enviar prueba
                                    </ButtonItem>
                                    <ButtonItem
                                        danger
                                        size="small"
                                        icon={<DeleteOutlined />}
                                        onClick={() => remove(name)}
                                    >
                                        Eliminar
                                    </ButtonItem>
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }

    renderSectionEnvioReportes() {
        const labelCol = { span: 14 };
        const wrapperCol = { span: 10 };

        return (
            <>
                {this.renderDivider("Envío Automático de Reportes")}
                <Text type="secondary" style={{ display: "block", marginBottom: 16, fontSize: 13 }}>
                    Elige cuáles reportes se envían por correo, cada cuánto, de qué plazo y a quién. El
                    correo llega con un resumen y el reporte adjunto en Excel y PDF. Con
                    <Text strong style={{ fontSize: 13 }}> Enviar prueba </Text>
                    lo mandas en ese momento a los destinatarios configurados para comprobar que funciona,
                    sin esperar al horario y sin necesidad de guardar primero.
                </Text>
                <div style={{ maxWidth: 520 }}>
                    <FormItem
                        label="Activar envío de reportes"
                        name={["envioReportes", "activa"]}
                        valuePropName="checked"
                        margin
                        labelCol={labelCol}
                        wrapperCol={wrapperCol}
                    >
                        <Switch />
                    </FormItem>
                </div>

                <FormItem shouldUpdate={(prev, curr) => prev.envioReportes?.activa !== curr.envioReportes?.activa} noStyle>
                    {({ getFieldValue }) => {
                        if (!getFieldValue(["envioReportes", "activa"])) return null;
                        return (
                            <Form.List name={["envioReportes", "programaciones"]}>
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.length === 0 && (
                                            <Text type="secondary" style={{ display: "block", marginBottom: 12, fontSize: 13 }}>
                                                Todavía no hay reportes programados.
                                            </Text>
                                        )}
                                        {fields.map((field) => this.renderProgramacionReporte(field, remove))}
                                        <ButtonItem
                                            type="dashed"
                                            onClick={() => add({ horaEnvio: 7, activa: true, formatos: ["excel", "pdf"] })}
                                            icon={<PlusOutlined />}
                                            block
                                            style={{ marginTop: 4, maxWidth: 320 }}
                                        >
                                            Agregar reporte programado
                                        </ButtonItem>
                                    </>
                                )}
                            </Form.List>
                        );
                    }}
                </FormItem>
            </>
        );
    }

    render() {
        const { selectedSection } = this.state;
        return (
            <Spin spinning={this.state.loading}>
                <Form
                    name="automatizacionConfiguracion"
                    layout
                    onFinish={this.onFinish.bind(this)}
                    ref={this.formRef}
                >
                    <Layout
                        style={{
                            background: "#fff",
                            border: "1px solid #f0f0f0",
                            borderRadius: 8,
                            overflow: "hidden",
                            minHeight: 520,
                        }}
                    >
                        {/* Sidebar */}
                        <Sider
                            breakpoint="md"
                            collapsedWidth={0}
                            theme="light"
                            width={185}
                            style={{
                                background: "#fff",
                                borderRight: "none",
                                boxShadow: "2px 0 8px rgba(0, 0, 0, 0.08)",
                                zIndex: this.state.isMobile ? 2 : "auto",
                                marginTop: this.state.isMobile ? -49 : 0,
                            }}
                        >
                            <div
                                style={{
                                    padding: "16px 16px 8px",
                                    fontSize: 10,
                                    fontWeight: 700,
                                    textTransform: "uppercase",
                                    letterSpacing: "0.6px",
                                    background: "#f5f5f5",
                                    borderBottom: "1px solid #efefef",
                                    color: "#8c8c8c",
                                }}
                            >
                                Módulos
                            </div>
                            <div style={{ paddingTop: 8 }}>
                                <Menu
                                    className="automatizacion-sidebar-menu"
                                    mode="inline"
                                    selectedKeys={[selectedSection]}
                                    items={MENU_ITEMS}
                                    onClick={({ key }) => this.setState({ selectedSection: key })}
                                    style={{ background: "transparent" }}
                                />
                            </div>
                        </Sider>

                        <Layout style={{ background: "#fff", display: "flex", flexDirection: "column" }}>
                            {/* Header de sección */}
                            <div
                                style={{
                                    background: "#f5f5f5",
                                    borderBottom: "1px solid #ebebeb",
                                    padding: "9px 24px",
                                    paddingLeft: this.state.isMobile ? 60 : 24,
                                    paddingBottom: this.state.isMobile ? 30 : 9,
                                    flexShrink: 0,
                                }}
                            >
                                <Text strong style={{ fontSize: 14, color: "#444" }}>
                                    {SECTION_TITLES[selectedSection]}
                                </Text>
                            </div>

                            {/* Contenido */}
                            <Content
                                style={{
                                    padding: this.state.isMobile ? "12px 12px 16px" : "16px 24px 24px",
                                    overflowY: "auto",
                                    flex: 1,
                                }}
                            >
                                {selectedSection === "facturaGlobal" && this.renderSectionFacturaGlobal()}
                                {selectedSection === "insumos" && this.renderSectionInsumos()}
                                {selectedSection === "alertasInventario" && this.renderSectionAlertasInventario()}
                                {selectedSection === "notificacionRequisicion" && this.renderSectionNotificacionRequisicion()}
                                {selectedSection === "envioReportes" && this.renderSectionEnvioReportes()}
                                {selectedSection === "revisionSbc" && this.renderSectionRevisionSbc()}
                            </Content>

                            {/* Footer */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    padding: "12px 10px",
                                    borderTop: "1px solid #f0f0f0",
                                    flexShrink: 0,
                                }}
                            >
                                <ButtonItem
                                    cyan
                                    type="primary"
                                    htmlType="submit"
                                    style={{
                                        minWidth: 120,
                                        height: 30,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                    }}
                                >
                                    Guardar Configuración
                                </ButtonItem>
                            </div>
                        </Layout>
                    </Layout>
                </Form>
            </Spin>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    // Módulos opcionales que habilitan reportes programables
    taxidermia: state.empresa.taxidermia,
    ventaOnline: state.empresa.ventaOnline,
});

export default connect(mapStateToProps)(AutomatizacionConfiguracion);
